import firebase from 'firebase';

// All HB 1416 tracker reads/writes go through district-admin-gated callables.
// RTDB org-write rules are permissive, so we never write the tracker node directly
// from the client. The callable names below are a hard contract with the backend.
const getHb1416TrackerEndpoint = firebase.functions().httpsCallable('getHb1416Tracker');
const updateHb1416TrackerEndpoint = firebase.functions().httpsCallable('updateHb1416Tracker');
const generateAEPEndpoint = firebase.functions().httpsCallable('generateAEP');
const generateAllAEPsEndpoint = firebase.functions().httpsCallable('generateAllAEPs');
const matchTiaDesignationsEndpoint = firebase.functions().httpsCallable('matchTiaDesignations');

// Returns the tracker map keyed by firebaseId plus the precomputed worklist.
export const getHb1416Tracker = async (snapshotYear) => {
  const result = await getHb1416TrackerEndpoint({ snapshotYear });
  return result && result.data;
};

// Log a single session and/or merge top-level fields onto a student's tracker node.
// session: { date, minutes, subject, provider, note }
// fields:  { waiverOnFile, ... }
export const updateHb1416Tracker = async (snapshotYear, firebaseId, session = null, fields = null) => {
  const result = await updateHb1416TrackerEndpoint({
    snapshotYear,
    firebaseId,
    session,
    fields,
  });
  return result && result.data;
};

// Generate the AEP PDF in the requested language and return its download URL.
// The response intentionally contains only { pdfUrl } (no provider hint).
export const generateAEP = async (snapshotYear, firebaseId, language) => {
  const result = await generateAEPEndpoint({ snapshotYear, firebaseId, language });
  return result && result.data;
};

// District-wide AEP generation (templated/custom narratives only, no model calls).
// Returns { total, generated, skippedExcluded, failed }.
export const generateAllAEPs = async (snapshotYear, language) => {
  const result = await generateAllAEPsEndpoint({ snapshotYear, language });
  return result && result.data;
};

// Check TEA's public TIA registry for the identified students' teachers.
// Returns { teachersChecked, confirmed, ambiguous, none, studentsExcluded }.
export const matchTiaDesignations = async (snapshotYear) => {
  const result = await matchTiaDesignationsEndpoint({ snapshotYear });
  return result && result.data;
};

export default 'hb1416Tracker.api.js';
